import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { ContentContainer } from "../Common/ContentContainer";
import SelectedKit from "./SelectedKit";
import KitPricingSummary from "./KitPricingSummary";

class KitPricingContainer extends Component {
    render() {
        const { tempCart, kitQuantity } = this.props;

        return (
            <div className="kit-pricing-summary-container">
                <ContentContainer>
                    <div className="row">
                        <div className="col-md-6">
                            <SelectedKit tempCart={tempCart} />
                        </div>
                        <div className="col-md-6">
                            <KitPricingSummary tempCart={tempCart} kitQuantity={kitQuantity} />
                        </div>
                    </div>
                </ContentContainer>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        cart: state.cart,
        tempCart: state.tempCart
    };
}

export default withRouter(connect(mapStateToProps, null)(KitPricingContainer));